function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//

// $FlowFixMe
import Uri from 'jsuri';
import * as React from 'react';
import range from 'lodash/range';
import { StyleSheet, css, font, breakPoint } from "../../../styles/theme";
import { CONFIG, LeftArrow, RightArrow, NumberBox } from "./PaginationButtons";
var styles = StyleSheet.create({
  Container: {
    marginTop: '6px',
    marginBottom: '6px'
  },
  numberButtons: _defineProperty({}, "@media (max-width: ".concat(breakPoint.sm, "px)"), {
    display: 'none'
  }),
  ellipsis: {
    fontSize: font.sm,
    display: 'inline-block'
  },
  buttonList: {
    padding: '0'
  }
});
var PaginationControls = /*#__PURE__*/function (_React$Component) {
  function PaginationControls() {
    var _this;
    _classCallCheck(this, PaginationControls);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, PaginationControls, [].concat(args));
    _defineProperty(_this, "onLeftClickHandler", function () {
      var _this$props = _this.props,
        onClickHandler = _this$props.onClickHandler,
        currentPage = _this$props.currentPage;
      var newPageNumber = Math.max(currentPage - 1, 1);
      if (newPageNumber !== currentPage && onClickHandler) {
        onClickHandler(newPageNumber);
      }
    });
    _defineProperty(_this, "onRightClickHandler", function () {
      var _this$props2 = _this.props,
        pageCount = _this$props2.pageCount,
        onClickHandler = _this$props2.onClickHandler,
        currentPage = _this$props2.currentPage;
      var newPageNumber = Math.min(currentPage + 1, pageCount);
      if (newPageNumber !== currentPage && onClickHandler) {
        onClickHandler(newPageNumber);
      }
    });
    _defineProperty(_this, "onNumberClickHandler", function (pageNumber) {
      var _this$props3 = _this.props,
        onClickHandler = _this$props3.onClickHandler,
        currentPage = _this$props3.currentPage;
      if (pageNumber !== currentPage && onClickHandler) {
        onClickHandler(pageNumber);
      }
    });
    _defineProperty(_this, "getUrlWithReplacedQueryParam", function (url, key, value, addQueryParamToFirstPage) {
      var destinationUrl = new Uri(url);
      var firstPageNumber = 1;
      // For cases where you don't want to add query params to the first page
      if (!addQueryParamToFirstPage) {
        if (destinationUrl.hasQueryParam(key) && value !== firstPageNumber) {
          return destinationUrl.replaceQueryParam(key, value).toString();
        } else if (value !== firstPageNumber) {
          return destinationUrl.addQueryParam(key, value).toString();
        }
        return destinationUrl.deleteQueryParam(key).toString();
      } else {
        // For cases where you want to add query params to the first page
        if (destinationUrl.hasQueryParam(key)) {
          destinationUrl.replaceQueryParam(key, value);
        } else {
          destinationUrl.addQueryParam(key, value);
        }
        return destinationUrl.toString();
      }
    });
    _defineProperty(_this, "getNumberBox", function (pageNumber) {
      var _this$props4 = _this.props,
        numberButtonStyle = _this$props4.numberButtonStyle,
        url = _this$props4.url,
        addQueryParamToFirstPage = _this$props4.addQueryParamToFirstPage,
        _this$props4$pageQuer = _this$props4.pageQueryParam,
        pageQueryParam = _this$props4$pageQuer === void 0 ? '' : _this$props4$pageQuer,
        currentPage = _this$props4.currentPage,
        selectedStyle = _this$props4.selectedStyle;
      var selected = pageNumber === currentPage;
      var props;
      if (url) {
        props = {
          key: "numberBox~".concat(pageNumber),
          num: pageNumber,
          style: numberButtonStyle,
          selected: selected,
          selectedStyle: selectedStyle,
          href: _this.getUrlWithReplacedQueryParam(url, pageQueryParam, pageNumber, addQueryParamToFirstPage)
        };
      } else {
        props = {
          key: "numberBox~".concat(pageNumber),
          num: pageNumber,
          style: numberButtonStyle,
          selectedStyle: selectedStyle,
          selected: selected,
          onClick: _this.onNumberClickHandler
        };
      }
      return /*#__PURE__*/React.createElement(NumberBox, props);
    });
    return _this;
  }
  _inherits(PaginationControls, _React$Component);
  return _createClass(PaginationControls, [{
    key: "getLeftArrow",
    value: function getLeftArrow(currentPage) {
      var _this$props5 = this.props,
        url = _this$props5.url,
        addQueryParamToFirstPage = _this$props5.addQueryParamToFirstPage,
        _this$props5$pageQuer = _this$props5.pageQueryParam,
        pageQueryParam = _this$props5$pageQuer === void 0 ? '' : _this$props5$pageQuer,
        arrowButtonStyle = _this$props5.arrowButtonStyle,
        disabledArrowButtonStyle = _this$props5.disabledArrowButtonStyle,
        _this$props5$dir = _this$props5.dir,
        dir = _this$props5$dir === void 0 ? '' : _this$props5$dir;
      var disabled = currentPage <= 1;
      var props;
      if (url) {
        props = {
          href: this.getUrlWithReplacedQueryParam(url, pageQueryParam, currentPage - 1, addQueryParamToFirstPage),
          style: disabled && !!disabledArrowButtonStyle ? disabledArrowButtonStyle : arrowButtonStyle,
          disabled: disabled,
          dir: dir
        };
      } else {
        props = {
          onClick: this.onLeftClickHandler,
          style: disabled && !!disabledArrowButtonStyle ? disabledArrowButtonStyle : arrowButtonStyle,
          disabled: disabled,
          dir: dir
        };
      }
      return /*#__PURE__*/React.createElement(LeftArrow, props);
    }
  }, {
    key: "getRightArrow",
    value: function getRightArrow(currentPage) {
      var _this$props6 = this.props,
        url = _this$props6.url,
        addQueryParamToFirstPage = _this$props6.addQueryParamToFirstPage,
        _this$props6$pageQuer = _this$props6.pageQueryParam,
        pageQueryParam = _this$props6$pageQuer === void 0 ? '' : _this$props6$pageQuer,
        arrowButtonStyle = _this$props6.arrowButtonStyle,
        disabledArrowButtonStyle = _this$props6.disabledArrowButtonStyle,
        pageCount = _this$props6.pageCount,
        _this$props6$dir = _this$props6.dir,
        dir = _this$props6$dir === void 0 ? '' : _this$props6$dir;
      var disabled = currentPage >= pageCount;
      var props;
      if (url) {
        props = {
          href: this.getUrlWithReplacedQueryParam(url, pageQueryParam, currentPage + 1, addQueryParamToFirstPage),
          style: disabled && !!disabledArrowButtonStyle ? disabledArrowButtonStyle : arrowButtonStyle,
          disabled: disabled,
          dir: dir
        };
      } else {
        props = {
          onClick: this.onRightClickHandler,
          style: disabled && !!disabledArrowButtonStyle ? disabledArrowButtonStyle : arrowButtonStyle,
          disabled: disabled,
          dir: dir
        };
      }
      return /*#__PURE__*/React.createElement(RightArrow, props);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props7 = this.props,
        pageCount = _this$props7.pageCount,
        maxPages = _this$props7.maxPages,
        collapseThreshold = _this$props7.collapseThreshold,
        ellipsisStyle = _this$props7.ellipsisStyle,
        buttonListStyle = _this$props7.buttonListStyle,
        style = _this$props7.style,
        currentPage = _this$props7.currentPage;
      if (pageCount === 0) {
        return null;
      }
      var body;

      // - Format: 1 2 3 4 5
      if (pageCount <= maxPages) {
        body = range(1, pageCount + 1).map(function (num) {
          return _this2.getNumberBox(num);
        });

        // - Format: 1 2 3 4 ... 10
      } else if (currentPage <= maxPages - collapseThreshold) {
        body = [range(1, maxPages).map(function (num) {
          return _this2.getNumberBox(num);
        }), /*#__PURE__*/React.createElement("li", _extends({
          key: "ellipsis~1"
        }, css(styles.ellipsis), {
          style: ellipsisStyle
        }), "..."), this.getNumberBox(pageCount)];

        // - Format: 1 ... 7 8 9 10
      } else if (currentPage >= pageCount - (maxPages - 1 - collapseThreshold)) {
        body = [this.getNumberBox(1), /*#__PURE__*/React.createElement("li", _extends({
          key: "ellipsis~1"
        }, css(styles.ellipsis), {
          style: ellipsisStyle
        }), "..."), range(pageCount - maxPages + 2, pageCount + 1).map(function (num) {
          return _this2.getNumberBox(num);
        })];

        // - Format: 1 ... 3 4 5 ... 10
      } else {
        var midSize = maxPages - collapseThreshold;
        var start = currentPage - Math.floor(midSize / 2);
        var end = currentPage + Math.ceil(midSize / 2);
        body = [this.getNumberBox(1), /*#__PURE__*/React.createElement("li", _extends({
          key: "ellipsis~1"
        }, css(styles.ellipsis), {
          style: ellipsisStyle
        }), "..."), range(start, end).map(function (num) {
          return _this2.getNumberBox(num);
        }), /*#__PURE__*/React.createElement("span", _extends({
          key: "ellipsis~2"
        }, css(styles.ellipsis), {
          style: ellipsisStyle
        }), "..."), this.getNumberBox(pageCount)];
      }
      return /*#__PURE__*/React.createElement("nav", _extends({
        "aria-label": "Pagination Controls"
      }, css(styles.Container), {
        style: style
      }), /*#__PURE__*/React.createElement("ul", _extends({}, css(styles.buttonList, 'cui-buttonList'), {
        style: buttonListStyle
      }), this.getLeftArrow(currentPage), body, this.getRightArrow(currentPage)));
    }
  }]);
}(React.Component);
_defineProperty(PaginationControls, "defaultProps", {
  addQueryParamToFirstPage: true,
  maxPages: 5,
  collapseThreshold: 2,
  currentPage: 1,
  numberButtonStyle: CONFIG.numberButton,
  arrowButtonStyle: CONFIG.arrowButton
});
export default PaginationControls;